import { Box, Button, TextField, Stack, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import './App.css';
import { useState } from "react";
import axios from "axios"

const testResultsBase = {
  "Student PID Returned": 0,
  "Lesser of Two Evens": 0,
  "Animal Crackers": 0,
  "Makes Twenty": 0,
  "Old MacDonald": 0,
  "Master Yoda": 0,
  "Almost There": 0,
  "Has 33": 0,
  "Paper Doll": 0,
  "Blackjack": 0,
  "Spy Game": 0,
}

const testResultTotals = {
  "Student PID Returned": 1,
  "Lesser of Two Evens": 2,
  "Animal Crackers": 2,
  "Makes Twenty": 3,
  "Old MacDonald": 1,
  "Master Yoda": 2,
  "Almost There": 4,
  "Has 33": 3,
  "Paper Doll": 2,
  "Blackjack": 3,
  "Spy Game": 3,
}

function App() {
  const [submittedUrl, setSubmittedUrl] = useState("")
  const [pid, setPid] = useState("")
  const [seed, setSeed] = useState(0)

  const [testResults, setTestResults] = useState({ ...testResultsBase })

  const runTest = () => {
    setSeed(Math.round(Math.random() * 100000))

    setTestResults({ ...testResultsBase })

    const baseInstance = axios.create({
      baseURL: submittedUrl,
      timeout: undefined
    });

    //get student pid
    baseInstance.get("/student_pid").then((data) => {
      setPid(data.data.result)
      setTestResults((prevTestResults) => {
        prevTestResults["Student PID Returned"]++
        return { ...prevTestResults }
      })
    }).catch((e) => {
      console.error(e)
    });

    //test lesser of two evens
    baseInstance.get("/lesser_of_two_evens", { params: { num1: 2, num2: 4 } }).then((data) => {
      if (data.data.result === 2) {
        setTestResults((prevTestResults) => {
          prevTestResults["Lesser of Two Evens"]++
          return { ...prevTestResults }
        })
      }
    }).catch((e) => {
      console.error(e)
    });
    baseInstance.get("/lesser_of_two_evens", { params: { num1: 2, num2: 5 } }).then((data) => {
      if (data.data.result === 5) {
        setTestResults((prevTestResults) => {
          prevTestResults["Lesser of Two Evens"]++
          return { ...prevTestResults }
        })
      }
    }).catch((e) => {
      console.error(e)
    });

    //test animal crackers
    baseInstance.get("/animal_crackers", { params: { text: "Levelheaded Llama" } }).then((data) => {
      if (data.data.result === true) {
        setTestResults((prevTestResults) => {
          prevTestResults["Animal Crackers"]++
          return { ...prevTestResults }
        })
      }
    }).catch((e) => {
      console.error(e)
    });
    baseInstance.get("/animal_crackers", { params: { text: "Crazy Kangaroo" } }).then((data) => {
      if (data.data.result === false) {
        setTestResults((prevTestResults) => {
          prevTestResults["Animal Crackers"]++
          return { ...prevTestResults }
        })
      }
    }).catch((e) => {
      console.error(e)
    });

    //test makes_twenty
    baseInstance.get("/makes_twenty", { params: { num1: 20, num2: 10 } }).then((data) => {
      if (data.data.result === true) {
        setTestResults((prevTestResults) => {
          prevTestResults["Makes Twenty"]++
          return { ...prevTestResults }
        })
      }
    }).catch((e) => {
      console.error(e)
    });
    baseInstance.get("/makes_twenty", { params: { num1: 12, num2: 8 } }).then((data) => {
      if (data.data.result === true) {
        setTestResults((prevTestResults) => {
          prevTestResults["Makes Twenty"]++
          return { ...prevTestResults }
        })
      }
    }).catch((e) => {
      console.error(e)
    });
    baseInstance.get("/makes_twenty", { params: { num1: 2, num2: 3 } }).then((data) => {
      if (data.data.result === false) {
        setTestResults((prevTestResults) => {
          prevTestResults["Makes Twenty"]++
          return { ...prevTestResults }
        })
      }
    }).catch((e) => {
      console.error(e)
    });

    //test old_macdonald
    baseInstance.get("/old_macdonald", { params: { name: "macdonald" } }).then((data) => {
      if (data.data.result === "MacDonald") {
        setTestResults((prevTestResults) => {
          prevTestResults["Old MacDonald"]++
          return { ...prevTestResults }
        })
      }
    }).catch((e) => {
      console.error(e)
    });

    //test master_yoda
    baseInstance.get("/master_yoda", { params: { text: "I am home" } }).then((data) => {
      if (data.data.result === "home am I") {
        setTestResults((prevTestResults) => {
          prevTestResults["Master Yoda"]++
          return { ...prevTestResults }
        })
      }
    }).catch((e) => {
      console.error(e)
    });
    baseInstance.get("/master_yoda", { params: { text: "We are ready" } }).then((data) => {
      if (data.data.result === "ready are We") {
        setTestResults((prevTestResults) => {
          prevTestResults["Master Yoda"]++
          return { ...prevTestResults }
        })
      }
    }).catch((e) => {
      console.error(e)
    });

    //test almost_there
    baseInstance.get("/almost_there", { params: { num: 90 } }).then((data) => {
      if (data.data.result === true) {
        setTestResults((prevTestResults) => {
          prevTestResults["Almost There"]++
          return { ...prevTestResults }
        })
      }
    }).catch((e) => {
      console.error(e)
    });
    baseInstance.get("/almost_there", { params: { num: 104 } }).then((data) => {
      if (data.data.result === true) {
        setTestResults((prevTestResults) => {
          prevTestResults["Almost There"]++
          return { ...prevTestResults }
        })
      }
    }).catch((e) => {
      console.error(e)
    });
    baseInstance.get("/almost_there", { params: { num: 150 } }).then((data) => {
      if (data.data.result === false) {
        setTestResults((prevTestResults) => {
          prevTestResults["Almost There"]++
          return { ...prevTestResults }
        })
      }
    }).catch((e) => {
      console.error(e)
    });
    baseInstance.get("/almost_there", { params: { num: 209 } }).then((data) => {
      if (data.data.result === true) {
        setTestResults((prevTestResults) => {
          prevTestResults["Almost There"]++
          return { ...prevTestResults }
        })
      }
    }).catch((e) => {
      console.error(e)
    });

    //test has_33
    baseInstance.get("/has_33", { params: { nums: JSON.stringify([1, 3, 3]) } }).then((data) => {
      if (data.data.result === true) {
        setTestResults((prevTestResults) => {
          prevTestResults["Has 33"]++
          return { ...prevTestResults }
        })
      }
    }).catch((e) => {
      console.error(e)
    });
    baseInstance.get("/has_33", { params: { nums: JSON.stringify([1, 3, 1, 3]) } }).then((data) => {
      if (data.data.result === false) {
        setTestResults((prevTestResults) => {
          prevTestResults["Has 33"]++
          return { ...prevTestResults }
        })
      }
    }).catch((e) => {
      console.error(e)
    });
    baseInstance.get("/has_33", { params: { nums: JSON.stringify([3, 1, 3]) } }).then((data) => {
      if (data.data.result === false) {
        setTestResults((prevTestResults) => {
          prevTestResults["Has 33"]++
          return { ...prevTestResults }
        })
      }
    }).catch((e) => {
      console.error(e)
    });

    //test paper_doll
    baseInstance.get("/paper_doll", { params: { text: "Hello" } }).then((data) => {
      if (data.data.result === "HHHeeellllllooo") {
        setTestResults((prevTestResults) => {
          prevTestResults["Paper Doll"]++
          return { ...prevTestResults }
        })
      }
    }).catch((e) => {
      console.error(e)
    });
    baseInstance.get("/paper_doll", { params: { text: "Mississippi" } }).then((data) => {
      if (data.data.result === "MMMiiissssssiiissssssiiippppppiii") {
        setTestResults((prevTestResults) => {
          prevTestResults["Paper Doll"]++
          return { ...prevTestResults }
        })
      }
    }).catch((e) => {
      console.error(e)
    });

    //test blackjack
    baseInstance.get("/blackjack", { params: { num1: 5, num2: 6, num3: 7 } }).then((data) => {
      if (data.data.result === 18) {
        setTestResults((prevTestResults) => {
          prevTestResults["Blackjack"]++
          return { ...prevTestResults }
        })
      }
    }).catch((e) => {
      console.error(e)
    });
    baseInstance.get("/blackjack", { params: { num1: 9, num2: 9, num3: 9 } }).then((data) => {
      if (data.data.result === "BUST") {
        setTestResults((prevTestResults) => {
          prevTestResults["Blackjack"]++
          return { ...prevTestResults }
        })
      }
    }).catch((e) => {
      console.error(e)
    });
    baseInstance.get("/blackjack", { params: { num1: 9, num2: 9, num3: 11 } }).then((data) => {
      if (data.data.result === 19) {
        setTestResults((prevTestResults) => {
          prevTestResults["Blackjack"]++
          return { ...prevTestResults }
        })
      }
    }).catch((e) => {
      console.error(e)
    });

    //test spy game
    baseInstance.get("/spy_game", { params: { nums: JSON.stringify([1, 2, 4, 0, 0, 7, 5]) } }).then((data) => {
      if (data.data.result === true) {
        setTestResults((prevTestResults) => {
          prevTestResults["Spy Game"]++
          return { ...prevTestResults }
        })
      }
    }).catch((e) => {
      console.error(e)
    });
    baseInstance.get("/spy_game", { params: { nums: JSON.stringify([1, 0, 2, 4, 0, 5, 7]) } }).then((data) => {
      if (data.data.result === true) {
        setTestResults((prevTestResults) => {
          prevTestResults["Spy Game"]++
          return { ...prevTestResults }
        })
      }
    }).catch((e) => {
      console.error(e)
    });
    baseInstance.get("/spy_game", { params: { nums: JSON.stringify([1, 7, 2, 0, 4, 5, 0]) } }).then((data) => {
      if (data.data.result === false) {
        setTestResults((prevTestResults) => {
          prevTestResults["Spy Game"]++
          return { ...prevTestResults }
        })
      }
    }).catch((e) => {
      console.error(e)
    });
  }

  return (
    <Box className="gradient" sx={{ width: "100vw", height: "100vh" }}>
      <Stack sx={{ width: "60%", position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", backgroundColor: "rgba(1,1,1,.3)", padding: 1, borderRadius: 2 }} spacing={1}>
        <TextField value={submittedUrl} onChange={(e) => {
          setSubmittedUrl(e.target.value)
        }} placeholder="Enter your URL from port forwarding here" sx={{ input: { color: 'white', textAlign: "center" } }} />
        <Button disabled={!submittedUrl} size="large" variant="contained" sx={{ backgroundColor: "white", color: "black" }} onClick={(e) => {
          runTest()
        }}>Submit</Button>
        {
          (Object.keys(testResults).every((key) => testResultTotals[key] === testResults[key]) || pid) && (
            <Box>
              <Typography>✅ <b>{pid}</b> has completed the lab! Please submit this image on Canvas. Seed: {seed}</Typography>
            </Box>
          )
        }
        <TableContainer>
          <Table sx={{ minWidth: 300 }}>
            <TableHead>
              <TableRow>
                <TableCell>Test</TableCell>
                <TableCell align="right">Test Passing</TableCell>
                <TableCell align="right">Total Tests</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Object.keys(testResults).map((key) => (
                <TableRow
                  key={key}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 }, backgroundColor: testResultTotals[key] === testResults[key] ? "green" : undefined }}
                >
                  <TableCell component="th" scope="row">
                    {key}
                  </TableCell>
                  <TableCell align="right">{testResults[key]}</TableCell>
                  <TableCell align="right">{testResultTotals[key]}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Stack>
    </Box>
  );
}

export default App;
